import { Component } from '@angular/core';

@Component({
  selector: 'app-logo-images',
  templateUrl: './logo-images.component.html',
  standalone: true
})
export class LogoImagesComponent {
  readonly skillCentralLogo = '/assets/images/skillcentral-logo.png';
}
